// Reducers...
import authReducer from "./reducers/authReducer";

// Sagas...
import authSaga from "./sagas/authSaga";

// Containers...
import SignInContainer from "./containers/SignInContainer";
// import SignUpContainer from "./containers/SignUpContainer";
import ForgotContainer from "./containers/ForgotContainer";

// Exports...
export const getReducers = createReducer => ({
	auth: authReducer(createReducer)
});
export const getSagas = () => [authSaga()];
export const getRoutes = () => ({
	signIn: {
		path: "/sign-in",
		layout: null,
		exact: true,
		component: SignInContainer,
		allowAnonymous: true,
		allowAuthorized: false
	},
	// signUp: {
	// 	path: "/sign-up",
	// 	layout: null,
	// 	exact: true,
	// 	component: SignUpContainer,
	// 	allowAnonymous: true,
	// 	allowAuthorized: false
	// },
	forgot: {
		layout: null,
		exact: true,
		path: ["/forgot", "/password-restored"],
		component: ForgotContainer,
		allowAnonymous: true,
		allowAuthorized: false
	}
});
